import { TwoColumnLayout } from '@factorialco/f0-react'

import MainContent from './_MainContent'
import SideContent from './_SideContent'
import type { MergedField, SectionType } from './types'

type NumerationState = {
  prefix: string
  format: string
}

type Props = {
  fields: MergedField[]
  numeration: NumerationState
  onToggleVisibility: (fieldKey: string, newVisible: boolean) => void
  onAddCustomField: (
    section: SectionType,
    label: string,
    fieldType: 'text' | 'select',
    options: string[]
  ) => void
  onNumerationChange: (numeration: NumerationState) => void
}

function FieldEditor({
  fields,
  numeration,
  onToggleVisibility,
  onAddCustomField,
  onNumerationChange,
}: Props) {
  return (
    <TwoColumnLayout
      mainColumnPosition="right"
      sideContent={
        <SideContent
          fields={fields}
          numeration={numeration}
          onToggleVisibility={onToggleVisibility}
          onAddCustomField={onAddCustomField}
          onNumerationChange={onNumerationChange}
        />
      }
    >
      <MainContent fields={fields} numeration={numeration} />
    </TwoColumnLayout>
  )
}

export type { NumerationState }
export default FieldEditor
